import { useFocusEffect } from 'expo-router';
import React from 'react'; // Duhet për React.useCallback
import { Platform } from 'react-native';

declare global {
  interface Window {
    Beacon: any;
  }
}

// Focused screens currently showing the beacon. When one beacon screen pushes
// another, the new screen's focus effect runs before the old screen's blur, so
// an unconditional destroy on blur would kill the beacon that was just created.
let focusedCount = 0;

function mountBeacon() {
  const scriptLoader = document.createElement('script');
  scriptLoader.id = 'helpscout-loader';
  scriptLoader.type = 'text/javascript';
  scriptLoader.innerHTML = `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`;

  document.head.appendChild(scriptLoader);

  const scriptInit = document.createElement('script');
  scriptInit.id = 'helpscout-init';
  scriptInit.type = 'text/javascript';
  scriptInit.innerHTML = `window.Beacon('init', '8f50e4b4-d1ee-4178-b08e-7656f8b11d65');`;

  document.head.appendChild(scriptInit);
}

function unmountBeacon() {
  if (window.Beacon) {
    window.Beacon('destroy');
  }
  const loader = document.getElementById('helpscout-loader');
  if (loader) loader.remove();

  const init = document.getElementById('helpscout-init');
  if (init) init.remove();

  const externalScript = document.querySelector('script[src="https://beacon-v2.helpscout.net"]');
  if (externalScript) externalScript.remove();
}

/**
 * Opens the beacon, optionally on a given route (e.g. '/ask', '/answers/').
 * Web only, and only on screens that render <HelpScoutBeacon />. Returns false
 * when there is no beacon to open so the caller can fall back.
 */
export function openHelpScoutBeacon(route?: string): boolean {
  if (Platform.OS !== 'web' || typeof window === 'undefined' || !window.Beacon) {
    return false;
  }
  window.Beacon('open');
  if (route) window.Beacon('navigate', route);
  return true;
}

export const HelpScoutBeacon = () => {
  useFocusEffect(
    React.useCallback(() => {
      if (Platform.OS !== 'web') {
        return;
      }

      focusedCount += 1;
      if (focusedCount === 1) mountBeacon();

      return () => {
        focusedCount -= 1;
        if (focusedCount === 0) unmountBeacon();
      };
    }, [])
  );

  return null;
}
